import { StorageService } from '../../auth/services/storage.service';
import {
  landingRouteForRole,
  USER_ADMIN_ROLES,
  UserRole,
} from '../../auth/types/auth.types';

export class RoleService {
  static getUserRole(): UserRole | null {
    try {
      const user = StorageService.getUser();
      return user?.role || null;
    } catch (error) {
      console.error('Error getting user role:', error);
      return null;
    }
  }

  static getUserName(): string | null {
    try {
      const user = StorageService.getUser();
      return user?.email || null;
    } catch (error) {
      console.error('Error getting user role:', error);
      return null;
    }
  }

  static hasRole(requiredRoles: UserRole[]): boolean {
    const userRole = this.getUserRole();
    if (!userRole) return false;
    
    return requiredRoles.includes(userRole);
  }

  static isAdmin(): boolean {
    return this.hasRole([UserRole.ADMIN, UserRole.SUPERADMIN]);
  }

  static isManager(): boolean {
    return this.hasRole([UserRole.ADMIN, UserRole.SUPERADMIN, UserRole.MANAGER]);
  }

  /**
   * Roles que administran usuarios (ven el menú "Usuarios" y aterrizan en
   * `/users`). Es exactamente el set de `isManager`, nombrado aparte para que
   * el landing/menú se lean por intención (2026-07-28, rol INDICADORES).
   */
  static canAdministerUsers(): boolean {
    return this.hasRole(USER_ADMIN_ROLES);
  }

  /**
   * Ruta de aterrizaje tras login / en `/`. Los roles que NO administran
   * usuarios (p.ej. `INDICADORES`, solo lectura del tablero) van directo a
   * `/indicadores` — mandarlos a `/users` mostraría una pantalla que su rol
   * no puede consultar (403 del backend).
   */
  static getLandingRoute(): string {
    return landingRouteForRole(this.getUserRole());
  }
}